import {
    SHOW_PUBLICITY,
    HIDE_PUBLICITY
} from "./type";

const initialState = {
    isPublicityShow: false,
};


const publicity = (state = initialState, action) => {
    switch (action.type) {

        case SHOW_PUBLICITY: {
            return {
                ...state,
                isPublicityShow: true,
            }
        }

        case HIDE_PUBLICITY: {
            return {
                ...state,
                isPublicityShow: false,
            }
        }

        default: {
            return {
                ...state,
            };
        }
    }
};

export default publicity;
